import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { useState, useEffect } from 'react';

const ScreenShotSlider = () => {
    const screenshots = [
        { src: "/assets/images/ScreenShot/dashboardss.png", alt: "Dashboard" },
        { src: "/assets/images/ScreenShot/forwordShipmentss.png", alt: "Shipment" },
        { src: "/assets/images/ScreenShot/trackss.png", alt: "TrackShipment" },
        { src: "/assets/images/ScreenShot/addWarehousess.png", alt: "AddWarehouse" },
        { src: "/assets/images/ScreenShot/viewWarehousess.png", alt: "ViewWarehouse" },
        { src: "/assets/images/ScreenShot/Ndrss.png", alt: "NDR" },
        { src: "/assets/images/ScreenShot/rateCalculatorss.png", alt: "RateCalculator" },
        { src: "/assets/images/ScreenShot/profile.png", alt: "Profile" },
        { src: "/assets/images/ScreenShot/help.png", alt: "Help" },
        { src: "/assets/images/ScreenShot/reports.png", alt: "Reports" },
        { src: "/assets/images/ScreenShot/rateCard.png", alt: "RateCard" },
        { src: "/assets/images/ScreenShot/kycPending.png", alt: "KycPending" },
    ];

    const [sliderHeight, setSliderHeight] = useState('420px');

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            if (width < 640) setSliderHeight('220px');
            else if (width < 1024) setSliderHeight('320px');
            else setSliderHeight('420px');
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <section style={{ padding: 0, margin: 0, display: 'block', lineHeight: 0, fontSize: 0 }}>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap');

                .slider-topbar {
                    font-family: 'DM Sans', sans-serif;
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    margin-top: 8px;
                    padding: 7px 14px;
                    background: #f9f7f2;
                    border-bottom: 1px solid #ede8de;
                    line-height: 1;
                    font-size: 14px;
                }

                .topbar-dot {
                    width: 10px;
                    height: 10px;
                    border-radius: 50%;
                    display: inline-block;
                    flex-shrink: 0;
                }
                .dot-red    { background: #ff6058; }
                .dot-yellow { background: #ffbd2e; }
                .dot-green  { background: #28c840; }

                .topbar-label {
                    margin-left: 8px;
                    margin-top: 8px;
                    font-size: 0.7rem;
                    font-weight: 600;
                    color: #aaa;
                    letter-spacing: 0.5px;
                    text-transform: uppercase;
                    line-height: 1;
                }

                .screenshot-swiper {
                    width: 100%;
                    display: block;
                }

                .screenshot-swiper .swiper-button-next,
                .screenshot-swiper .swiper-button-prev {
                    color: #1a1a2e;
                    background: #ffffffee;
                    border: 1px solid #ede8de;
                    width: 32px;
                    height: 32px;
                    border-radius: 50%;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
                    transition: background 0.2s;
                }

                .screenshot-swiper .swiper-button-next:hover,
                .screenshot-swiper .swiper-button-prev:hover {
                    background: #f9f7f2;
                }

                .screenshot-swiper .swiper-button-next::after,
                .screenshot-swiper .swiper-button-prev::after {
                    font-size: 11px;
                    font-weight: 700;
                }

                .screenshot-swiper .swiper-pagination-bullet {
                    background: #ccc;
                    opacity: 1;
                    width: 7px;
                    height: 7px;
                }

                .screenshot-swiper .swiper-pagination-bullet-active {
                    background: #2b7de9;
                    width: 20px;
                    border-radius: 4px;
                    transition: width 0.3s ease;
                }

                .slide-img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    object-position: top;
                    display: block;
                }

                .slide-badge {
                    position: absolute;
                    bottom: 36px;
                    left: 50%;
                    transform: translateX(-50%);
                    background: #1a1a2ecc;
                    color: #fff;
                    font-family: 'DM Sans', sans-serif;
                    font-size: 0.68rem;
                    font-weight: 600;
                    letter-spacing: 0.5px;
                    text-transform: uppercase;
                    padding: 3px 10px;
                    border-radius: 20px;
                    pointer-events: none;
                    white-space: nowrap;
                    line-height: 1.4;
                }
            `}</style>

            {/* Compact browser bar — zero gap to slider */}
            <div className="customers-section mt-16 ">
                <h2 className="customers-title">Application Overview</h2>
                <p className="customers-subtitle mt-8">Explore how our application works in real-time</p>

                <div className="slider-topbar mt-16">
                    <span className="topbar-dot dot-red" />
                    <span className="topbar-dot dot-yellow" />
                    <span className="topbar-dot dot-green" />
                    <span className="topbar-label">App Preview</span>
                </div>
            </div>

            {/* Full-width slider, flush against topbar */}
            <Swiper
                modules={[Navigation, Pagination, Autoplay]}
                slidesPerView={1}
                navigation
                pagination={{ clickable: true }}
                autoplay={{ delay: 2500, disableOnInteraction: false }}
                loop={true}
                className="screenshot-swiper"
                style={{ height: sliderHeight, display: 'block' }}
            >
                {screenshots.map((img, index) => (
                    <SwiperSlide key={index} style={{ position: 'relative' }}>
                        <img src={img.src} alt={img.alt} className="slide-img" />
                        <span className="slide-badge">{img.alt}</span>
                    </SwiperSlide>
                ))}
            </Swiper>
        </section>
    );
};

export default ScreenShotSlider;